// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages-dashboard {
  display: flex;
  height: 80%;
  background: rgba(26, 28, 34, 0.3);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 12px #0002;
  margin-left: 20px;  
  margin-right: 20px;  
}

.sidebar-users {
  width: 260px;
  /* background: #1a1d23; */
  /* Do that but 40% opacity  */
  background: rgba(26, 28, 34, 0.3);
  color: #fff;
  padding: 1rem 0.5rem;
  border-right: 1px solid #333;
  display: flex;
  flex-direction: column;
}

.user-search {
  margin: 0 0 1rem 0;
  padding: 0.5rem;
  border-radius: 5px;
  border: none;
  /* background: #2c2f36; */
  /* Do that but with 40% opacity */
    background: rgba(44, 47, 54, 0.3);
  color: #fff;
}

.user-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1 1;
  overflow-y: auto;
}

.user-list li {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 6px;
  margin-bottom: 0.2rem;
  transition: background 0.2s;
}

.user-list li.selected,
.user-list li:hover {
  /* background: #2c2f36; */
  background: rgba(26, 28, 34, 0.3);
}

.user-avatar {
  background: #4fd1c5;
  color: #222;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 0.7rem;
  font-size: 1.1rem;
}

.user-role {
  color: #aaa;
  font-size: 0.9em;
  margin-left: 0.3em;
}

.chat-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  /* background: #23272f; */
  background: rgba(44, 47, 54, 0.3);
}

.chat-header {
  padding: 1rem;
  border-bottom: 1px solid #333;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  /* background: #23272f; */
  background: rgba(44, 47, 54, 0.3);
  color: #fff;
}

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem;
  /* background: #23272f; */
  background: rgba(44, 47, 54, 0.3);
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.chat-message {
  max-width: 60%;
  padding: 0.7rem 1rem;
  border-radius: 12px;
  font-size: 1rem;
  position: relative;
  word-break: break-word;
}

.chat-message.from-me {
  align-self: flex-end;
  background: #4fd1c5;
  color: #222;
}

.chat-message.from-them {
  align-self: flex-start;
  background: #2c2f36;
  color: #fff;
}

.msg-meta {
  font-size: 0.8em;
  color: #888;
  margin-bottom: 0.2em;
  display: flex;
  justify-content: space-between;
}

.chat-input-row {
  display: flex;
  padding: 1rem;
  border-top: 1px solid #333;
  /* background: #23272f; */
  background: rgba(44, 47, 54, 0.3);
}

.chat-input {
  flex: 1 1;
  padding: 0.7rem;
  border-radius: 8px;
  border: none;
  /* background: #2c2f36; */
    background: rgba(44, 47, 54, 0.3);
  color: #fff;
  font-size: 1rem;
  margin-right: 0.7rem;
}

.send-btn {
  background: #4fd1c5;
  color: #222;
  border: none;
  border-radius: 8px;
  padding: 0.7rem 1.2rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
}

.send-btn:hover {
  background: #38b2ac;
}

.unread-badge {
  display: inline-block;
  background: #ff4d4f;
  color: #fff;
  border-radius: 1em;
  font-size: 0.8em;
  min-width: 1.5em;
  padding: 0 0.5em;
  margin-left: 0.5em;
  text-align: center;
  font-weight: bold;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/Messages.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,iCAAiC;EACjC,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;IAC/B,iCAAiC;EACnC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;IACvB,iCAAiC;EACnC,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB","sourcesContent":[".messages-dashboard {\n  display: flex;\n  height: 80%;\n  background: rgba(26, 28, 34, 0.3);\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 2px 12px #0002;\n  margin-left: 20px;  \n  margin-right: 20px;  \n}\n\n.sidebar-users {\n  width: 260px;\n  /* background: #1a1d23; */\n  /* Do that but 40% opacity  */\n  background: rgba(26, 28, 34, 0.3);\n  color: #fff;\n  padding: 1rem 0.5rem;\n  border-right: 1px solid #333;\n  display: flex;\n  flex-direction: column;\n}\n\n.user-search {\n  margin: 0 0 1rem 0;\n  padding: 0.5rem;\n  border-radius: 5px;\n  border: none;\n  /* background: #2c2f36; */\n  /* Do that but with 40% opacity */\n    background: rgba(44, 47, 54, 0.3);\n  color: #fff;\n}\n\n.user-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.user-list li {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem;\n  cursor: pointer;\n  border-radius: 6px;\n  margin-bottom: 0.2rem;\n  transition: background 0.2s;\n}\n\n.user-list li.selected,\n.user-list li:hover {\n  /* background: #2c2f36; */\n  background: rgba(26, 28, 34, 0.3);\n}\n\n.user-avatar {\n  background: #4fd1c5;\n  color: #222;\n  border-radius: 50%;\n  width: 2rem;\n  height: 2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  margin-right: 0.7rem;\n  font-size: 1.1rem;\n}\n\n.user-role {\n  color: #aaa;\n  font-size: 0.9em;\n  margin-left: 0.3em;\n}\n\n.chat-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  /* background: #23272f; */\n  background: rgba(44, 47, 54, 0.3);\n}\n\n.chat-header {\n  padding: 1rem;\n  border-bottom: 1px solid #333;\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  /* background: #23272f; */\n  background: rgba(44, 47, 54, 0.3);\n  color: #fff;\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem;\n  /* background: #23272f; */\n  background: rgba(44, 47, 54, 0.3);\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n\n.chat-message {\n  max-width: 60%;\n  padding: 0.7rem 1rem;\n  border-radius: 12px;\n  font-size: 1rem;\n  position: relative;\n  word-break: break-word;\n}\n\n.chat-message.from-me {\n  align-self: flex-end;\n  background: #4fd1c5;\n  color: #222;\n}\n\n.chat-message.from-them {\n  align-self: flex-start;\n  background: #2c2f36;\n  color: #fff;\n}\n\n.msg-meta {\n  font-size: 0.8em;\n  color: #888;\n  margin-bottom: 0.2em;\n  display: flex;\n  justify-content: space-between;\n}\n\n.chat-input-row {\n  display: flex;\n  padding: 1rem;\n  border-top: 1px solid #333;\n  /* background: #23272f; */\n  background: rgba(44, 47, 54, 0.3);\n}\n\n.chat-input {\n  flex: 1;\n  padding: 0.7rem;\n  border-radius: 8px;\n  border: none;\n  /* background: #2c2f36; */\n    background: rgba(44, 47, 54, 0.3);\n  color: #fff;\n  font-size: 1rem;\n  margin-right: 0.7rem;\n}\n\n.send-btn {\n  background: #4fd1c5;\n  color: #222;\n  border: none;\n  border-radius: 8px;\n  padding: 0.7rem 1.2rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.send-btn:hover {\n  background: #38b2ac;\n}\n\n.unread-badge {\n  display: inline-block;\n  background: #ff4d4f;\n  color: #fff;\n  border-radius: 1em;\n  font-size: 0.8em;\n  min-width: 1.5em;\n  padding: 0 0.5em;\n  margin-left: 0.5em;\n  text-align: center;\n  font-weight: bold;\n  vertical-align: middle;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
